import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDefault,
  },
  buttonHover: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgPressed,
  },
  buttonFocus: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDefault,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDisable,
  },

  icon: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
  iconHover: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
  iconPressed: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
  iconDisabled: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDisable,
  },
  iconFocus: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
});
